export default "__VITE_ASSET__KxmehfYB__"